<template>
  <IonItem class="inline-toggle-item" :class="`border-${border}`" lines="full" :color="gray ? 'whitesmoke' : 'white'">
    <IonLabel color="light" class="font-medium">
      <div class="flex items-center">
        <div class="flex justify-center" :class="icon ? 'w-10' : 'w-5'">
          <i
            v-if="icon"
            :class="{ [icon]: true, 'text-blue-500': iconColor === 'blue', 'text-gray-500': iconColor === 'gray' }"
            class="text-blue-500"
          ></i>
        </div>
        <span>{{ title }}</span>
      </div>
    </IonLabel>
    <Transition name="grow">
      <div
        v-if="showingSuccess"
        class="bg-green-100 rounded-full h-7 w-7 flex items-center justify-center border border-green-300 mr-2"
      >
        <i class="icon-check text-green-500"></i>
      </div>
    </Transition>
    <Transition name="grow">
      <div
        v-if="showingError"
        class="bg-red-100 rounded-full h-7 w-7 flex items-center justify-center border border-red-300 mr-2"
      >
        <i class="icon-x text-red-500 relative top-[1px]"></i>
      </div>
    </Transition>
    <IonToggle slot="end" v-model="vModel" color="primary" :disabled="disabled"></IonToggle>
  </IonItem>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/use-toast';
import { IonItem, IonLabel, IonToggle } from '@ionic/vue';
import { ref } from 'vue';

withDefaults(
  defineProps<{
    title: string;
    icon?: string;
    iconColor?: 'blue' | 'gray';
    gray?: boolean;
    border?: 'none' | 'bottom' | 'top' | 'default';
    disabled?: boolean;
  }>(),
  { border: 'default', iconColor: 'blue' }
);

const showingSuccess = ref(false);
const showingError = ref(false);

const { errorToast, successToast } = useToast();

function showSuccess(info?: { msg?: string; showForSeconds?: number }) {
  showingSuccess.value = true;
  setTimeout(() => (showingSuccess.value = false), (info?.showForSeconds || 1) * 1000);
  if (info?.msg) {
    successToast(info.msg);
  }
}

function showError(info?: { msg?: string; showForSeconds?: number }) {
  showingError.value = true;
  setTimeout(() => (showingError.value = false), (info?.showForSeconds || 3) * 1000);
  if (info?.msg) {
    errorToast(info.msg);
  }
}

defineExpose({
  showError,
  showSuccess,
});

const vModel = defineModel({ type: Boolean });
</script>

<style scoped>
ion-item.inline-toggle-item.border-default::part(native) {
  --border-width: 1px;
}
ion-item.inline-toggle-item.border-bottom::part(native) {
  --border-width: 0 0 2px 0;
}
ion-item.inline-toggle-item.border-top::part(native) {
  --border-width: 2px 0 0 0;
}

ion-item.inline-toggle-item {
  --inner-padding-top: 8px;
  --inner-padding-bottom: 8px;
  --inner-padding-start: 0px;
  --padding-start: 0px;
}
</style>
